/* Package JSON Import will be here */
import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

/* Package JSON Import will be here */
class PublicRoute extends Route {
    
    render() {
        switch (this.props.path) {
            case "/register":
                if (this.props.device.deviceFingerPrintId)
                    //&& (!this.props.device.isDeviceAlreadyRegistered)
                     {
                    return (
                        <Route component={this.props.component}
                            path={this.props.path} />
                    );
                }
                else {
                    return (
                        <Redirect to={{ pathname: '/' }} />
                    )
                }
            case "/login":
                if (this.props.device.deviceFingerPrintId && this.props.device.isDeviceAlreadyRegistered) {
                    return (
                        <Route component={this.props.component}
                            path={this.props.path} />
                    );
                }
                else {
                    return (
                        <Redirect to={{ pathname: '/' }} />
                    )
                }
            default:
                if (this.props.device.deviceFingerPrintId && this.props.device.isDeviceAlreadyRegistered) {
                    return (
                        <Route component={this.props.component}
                            path={this.props.path} />
                    );
                }
                else {
                    return (
                        <Redirect to={{ pathname: '/' }} />
                    )
                }
        }
    }
}
function mapStateToProps(state) {
    return { device: state.deviceReducer.device };
}

export default connect(mapStateToProps)(PublicRoute);